import type { KeyboardEventHandler } from "react";
import React, { forwardRef, useCallback } from "react";

import { useDropdownStore } from "../../../../store/store";
import { isCurrentKey } from "../../utils/keyboard";
import Base from "../Base/MenuBase";

import type { DropdownProps } from "../Base/types";

/**
 * Выпадающее меню, которое используется при поиске чего-либо.
 * @constructor
 */
export const Search = forwardRef<HTMLDivElement, DropdownProps>(
    ({ children, "data-tsid": tsid, ...props }, ref): JSX.Element => {
        const { buttonRef } = useDropdownStore();
        const focusToMenuButton = useCallback(() => {
            buttonRef.current?.focus();
        }, [buttonRef]);

        /**
         * При печати текста возвращаем фокус на элемент DropDownMenu.Button
         * @param e
         */
        const keyDownHandler: KeyboardEventHandler<HTMLDivElement> =
            useCallback(
                (e) => {
                    if (isCurrentKey(e.key)) {
                        focusToMenuButton();
                    }
                    props.onKeyDown?.(e);
                },
                [focusToMenuButton, props],
            );

        return (
            <Base
                {...props}
                onKeyDown={keyDownHandler}
                data-tsid={tsid}
                ref={ref}
            >
                {children}
            </Base>
        );
    },
);

Search.displayName = "SearchMenu.Search";

export default Search;
